export enum EnrollmentStatusPerson {
  ENROLLED = 'ENROLLED',
  NOT_ENROLLED = 'NOT_ENROLLED',
}

export const enrollmentStatusConfiguration = {
  [EnrollmentStatusPerson.ENROLLED]: {
    message: 'Enrolled in Drivers Benefits',
    color: '#16A34A',
    border: 'rgba(22, 163, 74, 0.08)',
    type: EnrollmentStatusPerson.ENROLLED,
  },
  [EnrollmentStatusPerson.NOT_ENROLLED]: {
    message: 'Enrollment Issue',
    color: '#F59E0B',
    border: 'rgba(245, 158, 11, 0.08)',
    type: EnrollmentStatusPerson.NOT_ENROLLED,
  },
}
